import type { IconNode } from '../types';

/**
 * @name shovel-dig
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTIgNi41Yy0xLjcgMC0zLTEuMy0zLTNWMmg2djEuNWMwIDEuNy0xLjMgMy0zIDMiIC8+CiAgPHBhdGggZD0iTTEyIDE2VjYuNSIgLz4KICA8cGF0aCBkPSJNOCAyMnYtNGEyIDIgMCAwIDEgMi0yaDRhMiAyIDAgMCAxIDIgMnY0IiAvPgogIDxwYXRoIGQ9Ik02IDIyaDEyIiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/shovel-dig
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const shovelDig: IconNode = [
  ['path', { d: 'M12 6.5c-1.7 0-3-1.3-3-3V2h6v1.5c0 1.7-1.3 3-3 3', key: '1dcnnr' }],
  ['path', { d: 'M12 16V6.5', key: '58fmdk' }],
  ['path', { d: 'M8 22v-4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v4', key: '10zdue' }],
  ['path', { d: 'M6 22h12', key: '14i54f' }],
];

export default shovelDig;
